export default "__VITE_ASSET__b045f896__"